import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { fromStore } from '../store';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard {
  constructor(
    private store: Store,
    private router: Router,
    private toastService: ToastService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.store.select(fromStore.selectAuthUser).pipe(
      map((user) => {
        if (user) {
          if (!this.store.selectSignal(fromStore.selectAuthVendor)()) {
            this.router.navigate(['/auth/sans-hote']);
            return false;
          }
          if (route.data['requiredPermission']) {
            if (
              user.all_permissions.includes(route.data['requiredPermission'])
            ) {
              return true;
            } else {
              this.toastService.error(
                "Vous n'avez pas l'autorisation d'accéder à cette page",
              );
              this.router.navigate(['/']);
              return false;
            }
          } else {
            return true;
          }
        }

        this.router.navigateByUrl('/auth/connexion', {
          state: { redirect: state.url },
        });
        return false;
      }),
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
